<div class="author w-100 q-page-header" [class.text-center]="isDesktop">
    <ng-container *ngIf="isDesktop">
        <h1 class="card-title q-page-header-title" [innerText]="title" ></h1>
        <span class="w-150px"></span>
    </ng-container>
    <h3 class="{{ isDesktop ? 'card-title q-page-header-sub-title mt-1' : 'text-muted fs-12 m-1 mt-3'}}" [innerText]="description"></h3>
</div>

    